import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for AddAlgo
export const AddAlgo = createSlice({
  name: "AddAlgo",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    add_AddAlgo: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_add_AddAlgo: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_add_AddAlgo: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
      state.switchResponse = true;
    },
    add_AddAlgo_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_AddAlgo_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchAddAlgo_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default AddAlgo.reducer;
export const {
  add_AddAlgo,
  success_api_call_add_AddAlgo,
  failure_api_call_add_AddAlgo,
  create_AddAlgo_complete_api,
  add_AddAlgo_is_success,
  false_switchAddAlgo_response
} = AddAlgo.actions;
